import { motion, AnimatePresence } from 'motion/react';
import PixelIcon from '@/components/ui/PixelIcon';
import { CARD_DEFINITIONS, RARITY_COLORS } from '@/config/cards';
import type { PixelIconName } from '@/components/ui/PixelIcon';
import type { CardInstance } from '@/types/card';

interface CardHandProps {
  cards: CardInstance[];
  onPlayCard: (cardId: string) => void;
}

const TILTS = [-6, 0, 6];

const CardHand: React.FC<CardHandProps> = ({ cards, onPlayCard }) => {
  if (cards.length === 0) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 'env(safe-area-inset-bottom, 12px)',
        left: '50%',
        transform: 'translateX(-50%)',
        display: 'flex',
        gap: 8,
        zIndex: 800,
      }}
    >
      <AnimatePresence>
        {cards.map((card, index) => {
          const def = CARD_DEFINITIONS[card.type];
          const tilt = TILTS[index] ?? 0;
          const borderColor = RARITY_COLORS[card.rarity];

          return (
            <motion.button
              key={card.id}
              initial={{ scale: 0, opacity: 0 }}
              animate={{ scale: 1, opacity: 1, rotate: tilt }}
              exit={{ scale: 1.5, opacity: 0 }}
              transition={{ duration: 0.3 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => onPlayCard(card.id)}
              title={def.name}
              aria-label={`Play ${def.name} card`}
              style={{
                width: 44,
                height: 44,
                border: `2px solid ${borderColor}`,
                borderRadius: 10,
                background: 'rgba(0,0,0,0.6)',
                backdropFilter: 'blur(4px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                padding: 0,
                color: '#fff',
              }}
            >
              <PixelIcon
                name={def.icon as PixelIconName}
                size={24}
                color="#fff"
              />
            </motion.button>
          );
        })}
      </AnimatePresence>
    </div>
  );
};

export default CardHand;
